<template>
  <b-modal
    :visible="visible"
    no-close-on-backdrop
    no-close-on-esc
    @hide="close"
  >
    <template #modal-header>
      <div class="d-flex w-100 border-bottom pb-2">
        <div class="w-100 text-left">
          <h2 class="mb-1">Motorista do {{ vehicleName }}</h2>
          <p class="mb-0 text-muted">{{ slotLabel }}</p>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Fechar"
          @click.prevent="close"
        >
          <span class="no no-e-remove"></span>
        </button>
      </div>
    </template>

    <el-select
      v-model="selectedUuid"
      filterable
      clearable
      :loading="loadingAgents"
      placeholder="Sem motorista"
      class="w-100"
    >
      <el-option
        v-for="agent in activeAgents"
        :key="agent.uuid"
        :label="agent.nickname ? `${agent.name} (${agent.nickname})` : agent.name"
        :value="agent.uuid"
      />
    </el-select>
    <p class="text-muted mt-2 mb-0 vehicle-driver-help">
      O motorista não ocupa vaga e é gravado nas reservas deste carro. Os outros
      condutores das reservas viajam como passageiros.
    </p>

    <template #modal-footer>
      <base-button type="secondary" @click="close">Cancelar</base-button>
      <base-button
        type="primary"
        :disabled="saving || selectedUuid === (currentUuid || '')"
        @click="confirm"
      >
        {{ saving ? 'Salvando...' : 'Confirmar' }}
      </base-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'VehicleDriverModal',

  props: {
    visible: { type: Boolean, default: false },
    vehicleName: { type: String, default: '' },
    slotLabel: { type: String, default: '' },
    currentUuid: { type: String, default: '' },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      loadingAgents: false,
      selectedUuid: '',
    }
  },

  computed: {
    ...mapGetters('agent', { agents: 'getAgents' }),

    activeAgents() {
      return (this.agents || []).filter(
        (agent) => agent.active === true || agent.active === 'true'
      )
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (!value) return
        this.selectedUuid = this.currentUuid || ''
        this.loadAgents()
      },
    },
  },

  methods: {
    ...mapActions('agent', ['getAllAgents']),

    async loadAgents() {
      if (this.activeAgents.length) return
      this.loadingAgents = true
      await this.getAllAgents()
      this.loadingAgents = false
    },

    close() {
      if (this.saving) return
      this.$emit('close')
    },

    // O PATCH do carro leva o condutor em driver.agent, no mesmo formato de
    // booking_add_agent_handler. A tela não chama essa rota.
    confirm() {
      if (!this.selectedUuid) {
        this.$emit('confirm', null)
        return
      }
      const agent = this.activeAgents.find((item) => item.uuid === this.selectedUuid)
      if (!agent) {
        this.$emit('confirm', this.selectedUuid)
        return
      }
      this.$emit('confirm', {
        uuid: agent.uuid,
        agent: {
          active: true,
          name: agent.name,
          uuid: agent.uuid,
          nickname: agent.nickname,
          place: agent.Place && agent.Place.name,
        },
      })
    },
  },
}
</script>

<style scoped>
.vehicle-driver-help {
  font-size: 0.85rem;
}
</style>
